"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var immutable_1 = require("immutable");
exports.ProgramRecord = immutable_1.Record({
    id: '',
    name: '',
    siteId: '',
    disabled: false,
});
/** Immutable SSG Program */
var Program = /** @class */ (function (_super) {
    __extends(Program, _super);
    function Program(props) {
        return _super.call(this, props) || this;
    }
    return Program;
}(exports.ProgramRecord));
exports.Program = Program;
;
//# sourceMappingURL=program.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@social-solutions/ssg-forms-processing/dist/form-definition/program.js
// module id = 1153
// module chunks = 0